import React, { Fragment, useState } from 'react'
import { Tag } from '../../Tags'

import '../index.scss'

const ShowHideMore = ({ keys, hide }) => {
  const [show, setShow] = useState(false)

  if (!keys || keys.length === 0) {
    return null
  }

  const names = show ? keys : keys.slice(0, 5)
  const tags = show ? hide : `+${keys.length - 5}`

  return (
    <Fragment>
      <span className='active-filters-name'>{names.join(', ')}</span>
      {keys.length > 5 && (
        <Tag
          onClick={() => setShow((show) => !show)}
          className='active-filters-tag'
        >
          {tags}
        </Tag>
      )}
    </Fragment>
  )
}

export default ShowHideMore
